"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runConstruction = void 0;
const error_1 = require("../error");
const actions_1 = require("../tx-compiler/actions");
const custom_send_all_1 = require("../utils/custom-send-all");
const onlyTxsAfterActionInclusive = (txs, actionName, construction) => {
    const actionCallIdxs = txs.findIndex((t) => t.type === "action calls");
    if (actionCallIdxs === -1)
        throw `Expected action call transactions in the construction`;
    const actionsAndAfter = txs.slice(actionCallIdxs);
    // Action transactions are double arrays where the outer corresponds to the action/ action group
    // and the inner to all the txs associated with the action/group
    const actionTxs = actionsAndAfter[0].txs;
    const actionIdx = construction.actions.findIndex((a) => a.actionName === actionName);
    if (actionIdx === -1)
        throw `Could not find action ${actionName} in the construction`;
    const actionTxIdx = construction.actionOrders.findIndex((orderSet) => orderSet.includes(actionIdx));
    if (actionTxIdx === -1)
        throw `Could not find ${actionName} in the construction's hit order`;
    const actionTxsShorted = actionTxs.slice(actionTxIdx);
    actionsAndAfter[0] = { txs: actionTxsShorted, type: "action calls" };
    return { actionsAndAfter, actionOrderOffset: actionTxIdx };
};
const runConstruction = (provider, construction, options, fromActionName) => __awaiter(void 0, void 0, void 0, function* () {
    let txsToRun = construction.txs;
    let actionOrderOffsetIdx = 0;
    if (fromActionName) {
        const { actionsAndAfter, actionOrderOffset } = onlyTxsAfterActionInclusive(construction.txs, fromActionName, construction.construction);
        txsToRun = actionsAndAfter;
        actionOrderOffsetIdx = actionOrderOffset;
    }
    const commitment = Object.assign({ preflightCommitment: "confirmed", commitment: "confirmed", skipPreflight: false }, ((options === null || options === void 0 ? void 0 : options.commitment) || {}));
    try {
        return yield (0, custom_send_all_1.sendAllTypedWithError)(provider, txsToRun, construction.construction, Object.assign(Object.assign({}, options), { commitment }), actionOrderOffsetIdx);
    }
    catch (e) {
        const eCast = e;
        if (eCast.txGroup === undefined)
            throw (0, error_1.newRunError)(e, construction.actionMap, commitment.skipPreflight, construction.construction.actions, "unknown");
        // Only count an action call as failed if the failure comes from the calling the action itself
        let actionIdx;
        let isMainActionCall = false;
        if (txsToRun[eCast.txGroup].type === "action calls") {
            const actionIdxInOrder = actionOrderOffsetIdx + eCast.txFailed.txIdx;
            const numbPrependedInstsPerActions = construction.construction.actionOrders[actionIdxInOrder].map((actionIdx) => {
                var _a, _b, _c;
                return (_c = (_b = (_a = construction.construction.actions[actionIdx].opts) === null || _a === void 0 ? void 0 : _a.instructions) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
            });
            const sumOfPrependedInst = numbPrependedInstsPerActions.reduce((p, v) => p + v, 0);
            // The transaction failed at a prepended instruction
            // TODO: test
            if (sumOfPrependedInst > eCast.txFailed.instrIdx) {
                isMainActionCall = false;
                let runningSum = 0;
                for (let i = 0; i < numbPrependedInstsPerActions.length; i++) {
                    runningSum += numbPrependedInstsPerActions[i];
                    if (eCast.txFailed.instrIdx < runningSum) {
                        actionIdx =
                            construction.construction.actionOrders[actionIdxInOrder][i];
                        break;
                    }
                }
            }
            else {
                actionIdx =
                    construction.construction.actionOrders[actionIdxInOrder][eCast.txFailed.instrIdx - sumOfPrependedInst];
                if ((0, actions_1.getMainActionTxIndex)(construction.construction.actions[actionIdx]) ===
                    eCast.txInner) {
                    isMainActionCall = true;
                }
            }
        }
        throw (0, error_1.newRunError)(eCast.err, construction.actionMap, commitment.skipPreflight, construction.construction.actions, txsToRun[eCast.txGroup].type, actionIdx, isMainActionCall);
    }
});
exports.runConstruction = runConstruction;
